import accordian from './accordion';
// import select from './select';
// import tabs from './tabs';
// import modal from './modal';
// import footerPosition from './footer-position';
import customScrollbar from './custom-scrollbar.js';
import horizontalDrag from './horizontal-drag.js';
import lazyLoad from './lazy-load.js';
import loadIn from './load-in.js';
import slider from './slider.js';
import touchSwipeDetection from './touch-swipe-detection.js';
import resizeReducedAnimation from './reduce-motion-on-resize.js';
import textSizeToContentWidth from './textsize-to-content-width.js';
import sidebarLinks from './sidebar-links';
import scrollDetect from './scroll-detect';
import flexboxGapSupport from './flexbox-gap-support';

export {
  horizontalDrag,
  lazyLoad,
  customScrollbar,
  slider,
  touchSwipeDetection,
  resizeReducedAnimation,
  textSizeToContentWidth,
  loadIn,
  accordian,
  sidebarLinks,
  scrollDetect,
  flexboxGapSupport
};
